<template>
  <label class="uk-margin" v-bind:for="name">
    <div class="uk-form-label uk-display-block" v-bind:for="name">
      <span v-html="label"></span>{{ required ? '*' : '' }}
    </div>

    <div class="kmc-field-help-text" v-if="helpText" v-html="helpText">
    </div>

    <select
        ref="input"
        :name="name"
        :id="name"
        :value="inputValue"
        :invalid="!meta.valid"
        @input="handleChange"
        @blur="handleBlur"
        :autocomplete="'none'"
    >
      <option v-for="v of options" :value="v">{{v}}</option>
    </select>

    <label class="kmc-input kmc-input-text">


      <div class="border"></div>

    </label>

    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>

  </label>

</template>

<script>

import {onMounted, ref, watch} from 'vue'
import {useField} from "vee-validate";

export default {
  name: "KmcInputSelect",
  components: {},
  props: {
    helpText: {
      type: String,
    },
    required: {},
    minLength: {},
    maxLength: {},
    options: {
      type: Array
    },
    value: {
      type: String
    },
    name: {
      type: String,
      default: "field name"
    },
    label: {
      type: String,
      default: "missing label"
    },
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      handleBlur,
      handleChange,
      meta,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });

    watch(errorMessage, (current, previous) => {
      input.value.setCustomValidity(current || '');
    })

    onMounted(() => {
      input.value.setCustomValidity(errorMessage.value || '');
    })

    return {
      input,
      handleChange,
      handleBlur,
      errorMessage,
      inputValue,
      meta,
    };
  }
}

</script>

